var React = require('react');

function ProductsIcon48Inline (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#1A1B21;}\n"),React.createElement("g",{"id":"Group_304","transform":"translate(-1076.999 -3012.478)","key":1},React.createElement("g",{"id":"Line_207"},React.createElement("polygon",{"className":"st0","points":"1105,3012.5 1105,3023.6 1102,3023.6 1102,3020 1080,3020 1080,3023.6 1077,3023.6 1077,3012.5 \n\t\t\t1080,3012.5 1080,3017 1089.5,3017 1089.5,3013.5 1092.5,3013.5 1092.5,3017 1102,3017 1102,3012.5 \t\t"})))]);
}

ProductsIcon48Inline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 28 11.1","style":{"enableBackground":"new 0 0 28 11.1"},"xmlSpace":"preserve","width":"25","height":"12"};

module.exports = ProductsIcon48Inline;

ProductsIcon48Inline.default = ProductsIcon48Inline;
